module.exports = __webpack_public_path__ + "img/stripe.ea1d6e6d.png";